import { render, staticRenderFns } from "./property-coverages.vue?vue&type=template&id=6dfb22c9&"
import script from "./property-coverages.vue?vue&type=script&lang=js&"
export * from "./property-coverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports